<template>
    <div class="form-group">
        <label :for="getId" v-text="getLabel"></label>
        <v-select
            v-model="currentObject"
            :options="articleTypes"
            :loading="isLoading || booting"
            label="title"
            ref="selector"
        ></v-select>
    </div>
</template>

<script>
    import fieldInfo from './../mixins/fieldInfo';
    import vSelect from 'vue-select';

    export default {
        name: "ArticleTypeSelect",
        components: {
            vSelect
        },
        mixins: [
            fieldInfo,
        ],
        data: function () {
            return {
                booting: true,
                currentObject: null,
            }
        },
        methods: {
            setObject(type) {
                this.currentValue = type.id;
                this.booting = false;
            }
        },
        computed: {
            articleTypes() {
                return this.$store.state.composer.articleTypes;
            },
            isLoading() {
                return this.$store.getters.isLoading('articleTypes');
            }
        },
        watch: {
            currentObject(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.setObject(newValue);
                }
            }
        },
        created(){
            this.$store.dispatch('boot', 'getArticleTypes').then(() => {
                this.booting = false;
                this.currentObject = this.value;
            });
        }
    }
</script>
